import Parent from '@/api/home/parent'
import { mapKeys, camelCase } from 'lodash'

import { baseState, baseMutations } from '@/store/mixins'

class Pagination {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}

export const state = {
  ...baseState,
  approve_status: null,
  app_type_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_APPROVE_STATUS(state, data) {
    state.approve_status = data
  },
  SET_APPROVAL_TYPES(state, data) {
    state.app_type_id = data
  },
  RECEIVE_RESOURCES(state, records) {
    const { data, ...meta } = records
    state.resources = data
    state.pagination = new Pagination(mapKeys(meta, (v, k) => camelCase(k)))
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        approve_status: context.state.approve_status,
        app_type_id: context.state.app_type_id
      },
      attrubutes
    )
    return Parent.getMyRequest({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response.data)
      return Promise.resolve(response)
    })
  }
}
